import React from "react";
import { Layout, Menu, Button } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  DashboardOutlined,
  UserOutlined,
  BookOutlined,
  AppstoreOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useNotification } from "../contexts/NotificationContext";

const { Header, Sider, Content } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { showSuccess } = useNotification();

  const handleLogout = () => {
    // Clear stored data
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    showSuccess("Logged out successfully");
    navigate("/login");
  };

  const menuItems = [
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
      onClick: () => navigate("/"),
    },
    {
      key: "courses",
      icon: <BookOutlined />,
      label: "Courses",
      onClick: () => navigate("/courses"),
    },
    {
      key: "categories",
      icon: <AppstoreOutlined />,
      label: "Categories",
      onClick: () => navigate("/categories"),
    },
    {
      key: "partners",
      icon: <TeamOutlined />,
      label: "Partners",
      onClick: () => navigate("/partners"),
    },
    {
      key: "users",
      icon: <UserOutlined />,
      label: "Users",
      onClick: () => navigate("/users"),
    },
    {
      key: "enrollments",
      icon: <TeamOutlined />,
      label: "Enrollments",
      onClick: () => navigate("/enrollments"),
    },
  ];

  const pathToKey: Record<string, string> = {
    "/": "dashboard",
    "/courses": "courses",
    "/categories": "categories",
    "/partners": "partners",
    "/users": "users",
    "/enrollments": "enrollments",
  };
  const selectedKey = pathToKey[location.pathname] || "dashboard";

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div
          style={{
            height: 64,
            margin: 16,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/logo-alt.png"}
            alt="Logo"
            style={{
              width: collapsed ? 32 : 120,
              transition: "width 0.2s",
              marginBottom: 8,
            }}
          />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: "#fff" }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: "16px", width: 64, height: 64 }}
          />
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            style={{ float: "right", margin: "16px 24px" }}
          >
            Logout
          </Button>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            background: "#fff",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
